import { createApi } from '@reduxjs/toolkit/query/react';

import {
  ExternalLoyaltyEndpoints as Endpoints,
  type CalculateExternalLoyaltyV1Request,
  type CalculateExternalLoyaltyV1Response,
  type GetLoyaltyCardsByLeadIdV1Request,
  type GetLoyaltyCardsByLeadIdV1Response,
  type GetLoyaltyCardsBySerialNumberV1Request,
  type GetLoyaltyCardsBySerialNumberV1Response,
} from '@app/api/ExternalLoyalty/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';
import { EXTERNAL_LOYALTY_CHUNK } from '@app/constants';

export const externalLoyaltyApi = createApi({
  reducerPath: 'externalLoyaltyApi',
  baseQuery: createApiBaseQuery(EXTERNAL_LOYALTY_CHUNK, { isBookHost: true }),
  endpoints: ({ mutation, query }) => ({
    [Endpoints.CalculateExternalLoyaltyV1]: mutation<
      CalculateExternalLoyaltyV1Response,
      CalculateExternalLoyaltyV1Request
    >({
      query: (data) => ({
        url: 'calculate',
        method: Methods.POST,
        data,
      }),
    }),
    [Endpoints.GetLoyaltyCardsByLeadIdV1]: mutation<
      GetLoyaltyCardsByLeadIdV1Response,
      GetLoyaltyCardsByLeadIdV1Request
    >({
      query: (data) => ({
        url: 'cards/by-lead',
        method: Methods.POST,
        data,
      }),
    }),
    [Endpoints.GetLoyaltyCardsBySerialNumberV1]: query<
      GetLoyaltyCardsBySerialNumberV1Response,
      GetLoyaltyCardsBySerialNumberV1Request
    >({
      query: ({ serialNumber }) => ({
        url: `cards/${serialNumber}`,
        method: Methods.GET,
      }),
    }),
  }),
});

export const {
  useCalculateExternalLoyaltyV1Mutation,
  useGetLoyaltyCardsByLeadIdV1Mutation,
  useLazyGetLoyaltyCardsBySerialNumberV1Query,
} = externalLoyaltyApi;
